import axios from "@/utils/axios.ts";

export const login = async (
  email: string,
  password: string,
  device_id: string
) => {
  const response = await axios.post("/api/auth/login", {
    email,
    password,
    device_id,
  });
  return response.data;
};

export const getTokenInfo = async () => {
  const response = await axios.get("/api/auth/token");
  return response.data;
};

export const getRefreshToken = async (
  accessToken: string,
  refreshToken: string
) => {
  const response = await axios.post("/api/auth/refresh_token", {
    access_token: accessToken,
    refresh_token: refreshToken,
  });
  return {
    access_token: response.data.access_token,
    refresh_token: response.data.refresh_token,
  };
};

export const changePassword = async (
  oldPassword: string,
  newPassword: string
) => {
  const response = await axios.post("/api/auth/change_password", {
    old_password: oldPassword,
    new_password: newPassword,
  });
  return response.data;
};

export const resetPassword = async (params: {
  email: string;
  first_name: string;
  last_name: string;
  gym_name: string;
}) => {
  const response = await axios.post("/api/auth/reset_password", {
    ...params,
  });
  return response.data;
};
